/**
 * GTM Pageview Event - Head Script
 *
 * Fires pageview event immediately after GTM data is available.
 * This script should be loaded in the head for early tracking.
 */
import { gtmLog } from '../gtm-front-handlers/gtm-logger';

// Fire pageview event immediately - GTM data should already be in head before this script.
( () => {
	// Get GTM data from window (set by PHP in head).
	const gtmData = window?.awcGTM;

	if ( ! gtmData ) {
		return;
	}

	// Initialize dataLayer if not exists.
	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push( gtmData );
	gtmLog( 'Pageview:', gtmData );

	document.addEventListener( 'awc-after-tab-update', () => {
		window.dataLayer.push( gtmData );
		gtmLog( 'Tab pageview:', gtmData );
	} );
} )();
